import {compareByMeetingResponse, GroupedMeetingAttendeesItem, MeetingAttendee, MeetingAttendeeType} from '../../data';

/** Comparator function to find and pop app user's attendee group
 * to the top of the list
 */
export const compareGroupsToPopUserGroupToTop = (
  a: GroupedMeetingAttendeesItem,
  b: GroupedMeetingAttendeesItem,
  userDirectoryObjectId: string,
) => {
  const isOrganizerInA = a.attendees.find(({directoryObjectId}) => directoryObjectId === userDirectoryObjectId);
  const isOrganizerInB = b.attendees.find(({directoryObjectId}) => directoryObjectId === userDirectoryObjectId);

  if (isOrganizerInA) {
    return -1;
  }

  if (isOrganizerInB) {
    return 1;
  }

  return 0;
};

/** Comparator function to find and pop app user's
 * default building group to the top of the list
 */
export const compareGroupsToPopDefaultBuildingToTop = (
  a: GroupedMeetingAttendeesItem,
  b: GroupedMeetingAttendeesItem,
  defaultBuildingId: string,
) => {
  const isADefaultBuilding = a.buildingId === defaultBuildingId;
  const isBDefaultBuilding = b.buildingId === defaultBuildingId;

  if (isADefaultBuilding) {
    return -1;
  }

  if (isBDefaultBuilding) {
    return 1;
  }

  return 0;
};

export const mapAttendeesToAttendeeGroups = (
  attendees: MeetingAttendee[],
  locationType: MeetingAttendeeType,
): GroupedMeetingAttendeesItem | undefined => {
  if (!attendees.length) {
    return;
  }

  return {
    attendees: [...attendees].sort(compareByMeetingResponse),
    id: locationType,
    buildingId: '',
    locationDescription: '',
    locationType,
  };
};
